export const REMINDER_ENTITY_TYPES = [
  'unit',
  'work_order',
  'compliance_record',
  'inspection',
  'building',
  'org',
] as const;
export type ReminderEntityType = (typeof REMINDER_ENTITY_TYPES)[number];

export const REMINDER_PRIORITIES = ['low', 'medium', 'high'] as const;
export type ReminderPriority = (typeof REMINDER_PRIORITIES)[number];

export const REMINDER_STATUSES = ['open', 'done', 'cancelled'] as const;
export type ReminderStatus = (typeof REMINDER_STATUSES)[number];

export const REMINDER_NOTIFICATION_STAGES = ['day_before', 'hour_before', 'overdue'] as const;
export type ReminderNotificationStage = (typeof REMINDER_NOTIFICATION_STAGES)[number];
